import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";
import { Header } from "@/components/site/Header";
import { HeroChicago } from "@/components/site/HeroChicago";
import { NorwoodQuiz } from "@/components/site/NorwoodQuiz";
import { ValueProps } from "@/components/site/ValueProps";
import { Footer } from "@/components/site/Footer";
import { WhyChooseChicago } from "@/components/site/WhyChooseChicago";
import { safeJsonLd } from "@/lib/structured-data";
import { getDallasHighlandParkStructuredData } from "@/lib/structured-data/dallas-highland-park";
import img__asset from "@/assets/restore/locations/dallas-highland-park.jpg.asset.json";
import { CITY_FAQS } from "@/content/wp-parity/faqs/city";

const Results = lazy(() => import("@/components/site/Results").then(m => ({ default: m.Results })));
const Reviews = lazy(() => import("@/components/site/Reviews").then(m => ({ default: m.Reviews })));
const NoShaveFuture = lazy(() => import("@/components/site/NoShaveFuture").then(m => ({ default: m.NoShaveFuture })));
const NoShaveWhy = lazy(() => import("@/components/site/NoShaveWhy").then(m => ({ default: m.NoShaveWhy })));
const Guarantee = lazy(() => import("@/components/site/Guarantee").then(m => ({ default: m.Guarantee })));
const Pricing = lazy(() => import("@/components/site/Pricing").then(m => ({ default: m.Pricing })));
const Surgeons = lazy(() => import("@/components/site/Surgeons").then(m => ({ default: m.Surgeons })));
const DoctorsGrid = lazy(() => import("@/components/site/DoctorsGrid").then(m => ({ default: m.DoctorsGrid })));
const LocationsMapGeneric = lazy(() => import("@/components/site/LocationsMapGeneric").then(m => ({ default: m.LocationsMapGeneric })));
const VirtualConsult = lazy(() => import("@/components/site/VirtualConsult").then(m => ({ default: m.VirtualConsult })));
const Faq = lazy(() => import("@/components/site/Faq").then(m => ({ default: m.Faq })));
const QuoteForm = lazy(() => import("@/components/site/QuoteForm").then(m => ({ default: m.QuoteForm })));

export const Route = createFileRoute("/locations/texas/dallas-highland-park")({
  head: () => ({
    meta: [
      { title: "Dallas Highland Park Hair Transplants | RESTORE Hair" },
      { name: "description", content: "RESTORE your confidence in Highland Park, Dallas, TX with RESTORE Hair Transplants, offering FUE & No Shave Hair Restoration. Get a free consult!" },
      { property: "og:title", content: "RESTORE® Hair Transplants in Dallas, Highland Park" },
      { property: "og:description", content: "Top hair restoration team serving Dallas – Highland Park. Soft, natural, undetectable results." },
      { property: "og:url", content: "https://restorehair.com/locations/texas/dallas-highland-park/" },
    ],
    links: [{ rel: "canonical", href: "https://restorehair.com/locations/texas/dallas-highland-park/" }],
    scripts: [{ type: "application/ld+json", children: safeJsonLd({ "@graph": getDallasHighlandParkStructuredData() }) }],
  }),
  component: Index,
});

function Index() {
  return (
    <div className="min-h-screen bg-background font-sans">
      <Header />
      <main>
        <HeroChicago
          h1="Dallas Highland Park Hair Transplants"
          eyebrow="RESTORE® | Dallas – Highland Park Hair Transplants"
          subheading="RESTORE your confidence with the #1 hair restoration team in Dallas – Highland Park"
          extraParagraph="Find out about your hair transplant options in Dallas – Highland Park."
        />
        <NorwoodQuiz />
        <WhyChooseChicago />
        <Suspense fallback={null}>
          <div className="hidden md:block"><Results /></div>
          <ValueProps hideEyebrowMobile />
          <NoShaveFuture />
          <NoShaveWhy dougLeft />
          <Reviews />
          <Guarantee />
          <Pricing city="Dallas – Highland Park" />
          <VirtualConsult />
          <Surgeons
            eyebrow="RESTORE Dallas – Highland Park Hair Transplant Doctors"
            heading={<>A World Renowned <span className="text-foreground">Team</span></>}
          />
          <DoctorsGrid />
          <LocationsMapGeneric
            city="Dallas – Highland Park"
            stateName="Texas"
            addressLine1="4514 Cole Avenue, Office #605"
            addressLine2="Dallas, TX"
            mapQuery="4514 Cole Avenue Dallas TX"
            img={img__asset.url}
          />
          <Faq items={CITY_FAQS} />
          <QuoteForm />
        </Suspense>
      </main>
      <Footer />
    </div>
  );
}
